import { useParams } from 'react-router-dom';

import { AppCreateCategoryPage } from '~/components/pages/AppCreateCategoryPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppCreateCategoryRoute: React.FC = () => {
  const { appId, categoryId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppCreateCategoryPage appId={appId} parentCategoryId={categoryId} />
    </DashboardTemplate>
  );
};
